import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NbGlobalPhysicalPosition, NbGlobalPosition, NbToastrService, NbComponentStatus } from '@nebular/theme';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'add-edit-national-account',
  templateUrl: './add-edit-national-account.component.html',
  styleUrls: ['./add-edit-national-account.component.scss']
})
export class AddEditNationalAccountComponent implements OnInit {
  public rootURL: string = environment.baseUrl;
  serviceList: any;
  subServiceList: any;
  nationalAccountProgramList: any;
  nationalAccountDetails: UntypedFormGroup;
  loading: boolean;
  editLog: number = 0;
  accountName: any;
  custKey: any;
  nationalAccountKey: any = 0;
  prioritys = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  submitted = false;
  isEdit = false;

  destroyByClick = true;
  duration = 5000;
  hasIcon = true;
  position: NbGlobalPosition = NbGlobalPhysicalPosition.TOP_RIGHT;
  preventDuplicates = false;
  statusSuccess: 'success';
  statusFailure: 'warning';
  message: string;
  arrNationalAccountDetails: any = [];

  constructor(
    public dialogRef: MatDialogRef<AddEditNationalAccountComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private formBuilder: UntypedFormBuilder,
    private toastrService: NbToastrService,
    public dialog: MatDialog,
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    if (sessionStorage.getItem('hierachy').toString() === 'Corporate') {
      this.custKey = sessionStorage.getItem('legacyCustomerKeyId');
    } else if (sessionStorage.getItem('hierachy').toString() === 'Region') {
      this.custKey = sessionStorage.getItem('ersSubcustomerId');
    }

    if (this.data.data != 0) {
      this.isEdit = true;
      this.editLog = 1;
    }

    this.arrNationalAccountDetails = this.data.arrNationalAccountDetails;
    this.getpopupData();
    this.nationalAccountDetails = this.formBuilder.group({
      napService: [{ value: 972, disabled: true }],
      napSubService: ['', [Validators.required]],
      napParentAccounts: ['', [Validators.required]],
      napPriority: ['', [Validators.required]],
      napAccountNumber: [''],
      napPoMask: ['TTN WO#']
    });
  }

  getpopupData() {
    const serviceReq = this.http.get(environment.baseUrl + `api/vendorSearch/GetVendorServiceSearch`);
    const subServiceReq = this.http.get(environment.baseUrl + `api/vendorSearch/GetVendorSubServiceSearch/972`);
    const nationalAccountProgramNameReq = this.http.get(this.rootURL + `getNationalAccountProgramName`);

    this.loading = true;
    forkJoin([serviceReq, subServiceReq, nationalAccountProgramNameReq]).subscribe((response: any) => {
      this.loading = false;
      this.serviceList = response[0].body;
      this.subServiceList = response[1].body;
      this.nationalAccountProgramList = response[2].response;

      if (this.data.data != 0) {
        this.nationalAccountDetails.get('napService').setValue(this.data.data.serviceKey);
        this.nationalAccountDetails.get('napSubService').setValue(this.data.data.subServiceKey);
        this.nationalAccountDetails.get('napPriority').setValue(this.data.data.nationalAccountPriority);
        this.nationalAccountDetails.get('napParentAccounts').setValue(this.data.data.napParentAccountKey);
        this.nationalAccountDetails.get('napAccountNumber').setValue(this.data.data.nationalAccountNumber);
        this.nationalAccountDetails.get('napPoMask').setValue(this.data.data.nationalAccountPOMask);
        this.nationalAccountDetails.get('napSubService').disable();
        this.nationalAccountProgramList.forEach(nap => {
          if (nap.nationalAccountKey == this.data.data.napParentAccountKey) {
            this.accountName = nap.nationalAccountProgram;
          }
        });
      }
    }, (error) => {
      this.loading = false;
      console.error('AddEditNationalAccountComponent_getpopupData', error);
    });
  }

  onNoClick(): void {
    this.dialogRef.close(0);
  }

  addNationalAccount() {
    if (this.nationalAccountDetails.invalid) {
      this.submitted = true;
      return false;
    } else {
      this.submitted = false;
    }

    let intNapSubService = this.isEdit ? [this.nationalAccountDetails.get('napSubService').value] : this.nationalAccountDetails.get('napSubService').value;
    if (this.editLog > 0) {
      this.nationalAccountKey = this.data.data.nationalAccountKey;
    } else {
      this.nationalAccountKey = 0;
    }
    let intValidationCount = 0;
    let continueProcess = 0;
    this.arrNationalAccountDetails.forEach(nap => {
      if (nap.serviceKey == this.nationalAccountDetails.get('napService').value &&
        (nap.subServiceKey == intNapSubService || (intNapSubService.indexOf(nap.subServiceKey) !== -1)) &&
        nap.nationalAccountPriority == this.nationalAccountDetails.get('napPriority').value) {
        if (this.isEdit && nap.nationalAccountKey == this.nationalAccountKey) {
          if (intValidationCount > 0) {
            alert(nap.subServiceName + ' already set priority ' + this.nationalAccountDetails.get('napPriority').value + '. \nPlease select other priority.');
            continueProcess++;
            return false;
          }
          intValidationCount++;
        } else {
          alert(nap.subServiceName + ' already set priority ' + this.nationalAccountDetails.get('napPriority').value + '. \nPlease select other priority.');
          continueProcess++;
          return false;
        }
      }
    });

    if (continueProcess > 0) { return false; }

    this.loading = true;
    const data = {
      'napService': this.nationalAccountDetails.get('napService').value,
      'napSubService': this.isEdit ? [this.nationalAccountDetails.get('napSubService').value] : this.nationalAccountDetails.get('napSubService').value,
      'napParentAccount': this.nationalAccountDetails.get('napParentAccounts').value,
      'napPriority': this.nationalAccountDetails.get('napPriority').value,
      'napAccountNumber': this.nationalAccountDetails.get('napAccountNumber').value,
      'napPoMask': this.nationalAccountDetails.get('napPoMask').value,
      'custKey': this.custKey,
      'napParentaccountName': this.accountName,
      'nationalAccountKey': this.nationalAccountKey,
    }

    this.http.post(this.rootURL + `addNationalAccountProgram`, data).subscribe((response: any) => {
      if (response.status) {
        this.message = this.editLog > 0 ? 'National account updated successfully.' : 'National account added successfully.';
        this.showToast(this.statusSuccess, this.position, this.message);
        this.loading = false;
      } else {
        this.message = this.editLog > 0 ? 'Failed to updated national account.' : 'Failed to add national account.';
        this.showToast(this.statusFailure, this.position, this.message);
        this.loading = false;
      }
      this.loading = false;
      this.dialogRef.close(1);
    }, (error) => {
      this.loading = false;
      console.error('AddEditNationalAccountComponent_addNationalAccount', error);
    });
  }

  setParentAccountName(event) {
    this.accountName = event.source.selected._element.nativeElement.innerText;
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: this.destroyByClick,
      duration: this.duration,
      hasIcon: this.hasIcon,
      position: this.position,
      preventDuplicates: this.preventDuplicates,
    };
    const toastFooter = '';
    const titleContent = body;
    this.toastrService.show(
      toastFooter,
      `${titleContent}`,
      config);
  }
}
